(function () {
  'use strict';

  var pathname = window.location.pathname;
  try {
    pathname = decodeURIComponent(pathname);
  } catch (error) {
    pathname = window.location.pathname;
  }
  pathname = pathname.replace(/\/+$/, '');

  var pages = {
    '/products/aro': {
      handle: 'aro',
      productId: 9371197440301,
      fixedVariantId: null,
      allowedVariantIds: [48788951105837, 48788951138605, 48854559785261, 48854559818029],
      pendingDisplay: false
    },
    '/products/מגבת-בריסטה-לקפה-mhw-3bomber': {
      handle: 'מגבת-בריסטה-לקפה-mhw-3bomber',
      productId: 10275451863341,
      fixedVariantId: 52054582886701,
      allowedVariantIds: [52054582886701],
      pendingDisplay: true
    },
    '/products/פאק-סקרין-58-מ-מ-mhw-3bomber': {
      handle: 'פאק-סקרין-58-מ-מ-mhw-3bomber',
      productId: 10275451535661,
      fixedVariantId: 52054581412141,
      allowedVariantIds: [52054581412141],
      pendingDisplay: true
    }
  };
  var config = pages[pathname];
  if (!config) return;

  var state = {
    root: null,
    form: null,
    status: null,
    product: null,
    ready: false,
    busy: false,
    request: null
  };

  function addStyle() {
    if (document.getElementById('bs-targeted-product-binding-style')) return;
    var style = document.createElement('style');
    style.id = 'bs-targeted-product-binding-style';
    style.textContent =
      '.bs-targeted-product-pending .gf_product-title,' +
      '.bs-targeted-product-pending .gf_product-price,' +
      '.bs-targeted-product-pending .gf_product-compare-price,' +
      '.bs-targeted-product-pending .gf_product-image{' +
      'visibility:hidden!important}' +
      '.bs-targeted-product-status{' +
      'margin:8px 0 0;padding:0;min-height:1.4em;font-size:13px;' +
      'line-height:1.5;color:#555}' +
      '.bs-targeted-product-status[data-error="true"]{color:#9b2c20}' +
      '.bs-targeted-product-status[data-success="true"]{color:#286b48}';
    document.head.appendChild(style);
  }

  function visible(element) {
    if (!element) return false;
    var node = element;
    while (node && node !== document.documentElement) {
      var computed = window.getComputedStyle(node);
      if (computed.display === 'none' || computed.visibility === 'hidden' ||
          computed.visibility === 'collapse') return false;
      node = node.parentElement;
    }
    var rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function findHero() {
    var modules = document.querySelectorAll('.module-wrap[data-label="Product"]');
    for (var i = 0; i < modules.length; i += 1) {
      var root = modules[i];
      if (!visible(root)) continue;
      var form = root.querySelector('form');
      if (!form || !form.querySelector('input[name="id"]') ||
          !form.querySelector('.gf_add-to-cart')) continue;
      if (!root.querySelector('.gf_product-title') ||
          !root.querySelector('.gf_product-price') ||
          !root.querySelector('.gf_product-image')) continue;
      return { root: root, form: form };
    }
    return null;
  }

  function setStatus(message, kind) {
    if (!state.status) return;
    if (state.status.textContent !== message) state.status.textContent = message;
    state.status.setAttribute('data-error', kind === 'error' ? 'true' : 'false');
    state.status.setAttribute('data-success', kind === 'success' ? 'true' : 'false');
  }

  function ensureStatus(root) {
    var status = root.querySelector('.bs-targeted-product-status');
    if (!status) {
      status = document.createElement('p');
      status.className = 'bs-targeted-product-status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      root.appendChild(status);
    }
    return status;
  }

  function setButtonsDisabled(disabled) {
    if (!state.form) return;
    var buttons = state.form.querySelectorAll('.gf_add-to-cart');
    for (var i = 0; i < buttons.length; i += 1) {
      buttons[i].disabled = !!disabled;
      buttons[i].setAttribute('aria-disabled', disabled ? 'true' : 'false');
    }
  }

  function selectedVariant() {
    if (!state.product || !state.form) return null;
    var input = state.form.querySelector('input[name="id"]');
    var id = config.fixedVariantId || (input ? Number(input.value) : 0);
    if (!id) return null;
    var variants = state.product.variants || [];
    for (var i = 0; i < variants.length; i += 1) {
      if (Number(variants[i].id) === Number(id)) return variants[i];
    }
    return null;
  }

  function amountFromPrice(value) {
    if (typeof value === 'string' && value.indexOf('.') !== -1) {
      return Number(value);
    }
    return Number(value) / 100;
  }

  function formatILS(value) {
    var amount = amountFromPrice(value);
    if (!isFinite(amount)) return '';
    var rendered;
    try {
      rendered = amount.toLocaleString('he-IL', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
    } catch (error) {
      rendered = String(amount);
    }
    return '₪' + rendered;
  }

  function imageUrl(variant, product) {
    var variantImage = variant && variant.featured_image;
    if (variantImage && typeof variantImage === 'object') {
      variantImage = variantImage.src || variantImage.url || '';
    }
    if (variantImage) return variantImage;
    if (product.featured_image) return product.featured_image;
    return (product.images && product.images[0]) || '';
  }

  function setTextIfChanged(element, value) {
    if (element && element.textContent !== value) element.textContent = value;
  }

  function setAttributeIfChanged(element, name, value) {
    if (!element) return;
    var rendered = String(value);
    if (element.getAttribute(name) !== rendered) element.setAttribute(name, rendered);
  }

  function applyProductData(variant) {
    if (!state.root || !state.form || !state.product || !variant) return;
    var product = state.product;
    var productId = String(product.id);
    var variantId = String(variant.id);
    var input = state.form.querySelector('input[name="id"]');

    if (config.fixedVariantId && input) {
      if (input.value !== variantId) input.value = variantId;
      setAttributeIfChanged(input, 'value', variantId);
    }
    if (input) setAttributeIfChanged(input, 'data-productid', productId);
    setAttributeIfChanged(state.form, 'data-productid', productId);

    var productModules = state.root.querySelectorAll('[data-pid]');
    for (var i = 0; i < productModules.length; i += 1) {
      setAttributeIfChanged(productModules[i], 'data-pid', productId);
    }
    var currentVariantModules = state.root.querySelectorAll('[data-current-variant]');
    for (var j = 0; j < currentVariantModules.length; j += 1) {
      setAttributeIfChanged(currentVariantModules[j], 'data-current-variant', variantId);
    }

    var titleLinks = state.root.querySelectorAll('.gf_product-title');
    for (var k = 0; k < titleLinks.length; k += 1) {
      setTextIfChanged(titleLinks[k], product.title || '');
      if (titleLinks[k].tagName === 'A') {
        setAttributeIfChanged(titleLinks[k], 'href', product.url || window.location.pathname);
      }
    }

    var price = formatILS(variant.price);
    var prices = state.root.querySelectorAll('.gf_product-price');
    for (var p = 0; p < prices.length; p += 1) {
      setTextIfChanged(prices[p], price);
      setAttributeIfChanged(prices[p], 'data-price', String(variant.price));
    }

    var compare = Number(variant.compare_at_price || 0);
    var current = Number(variant.price || 0);
    var compareNodes = state.root.querySelectorAll('.gf_product-compare-price');
    for (var c = 0; c < compareNodes.length; c += 1) {
      if (compare > current) {
        setTextIfChanged(compareNodes[c], formatILS(variant.compare_at_price));
        compareNodes[c].style.display = '';
      } else {
        compareNodes[c].style.display = 'none';
      }
    }

    var selectedImage = imageUrl(variant, product);
    var images = product.images || [];
    var imageNodes = state.root.querySelectorAll('img.gf_product-image');
    for (var m = 0; m < imageNodes.length; m += 1) {
      var image = imageNodes[m];
      var url = images[m] || selectedImage;
      if (!url) continue;
      setAttributeIfChanged(image, 'src', url);
      setAttributeIfChanged(image, 'data-zoom', url);
      if (image.hasAttribute('data-src')) setAttributeIfChanged(image, 'data-src', url);
      if (image.hasAttribute('data-lazy-src')) setAttributeIfChanged(image, 'data-lazy-src', url);
      setAttributeIfChanged(image, 'alt', product.title || '');
      if (image.hasAttribute('srcset')) image.removeAttribute('srcset');
      var imageLink = image.closest('a');
      if (imageLink) setAttributeIfChanged(imageLink, 'href', product.url || window.location.pathname);
    }

    var productJson = state.form.querySelector('script.product-json');
    if (productJson) {
      setAttributeIfChanged(productJson, 'id', 'product-json' + productId);
      var serialized = JSON.stringify(product);
      if (productJson.textContent !== serialized) productJson.textContent = serialized;
    }

    var cartModules = state.root.querySelectorAll('[data-cbto="custom"]');
    if (config.handle === 'aro') {
      for (var d = 0; d < cartModules.length; d += 1) {
        setAttributeIfChanged(cartModules[d], 'data-editlink', '/cart');
      }
    }
  }

  function refreshSelection() {
    if (!state.ready || !state.form || !state.product) {
      setButtonsDisabled(true);
      return null;
    }
    var variant = selectedVariant();
    if (!variant) {
      setButtonsDisabled(true);
      setStatus('לא הצלחנו לאמת את האפשרות שנבחרה. רעננו את הדף ונסו שוב.', 'error');
      return null;
    }
    applyProductData(variant);
    var available = variant.available === true;
    setButtonsDisabled(state.busy || !available);
    if (!available && !state.busy) {
      setStatus('האפשרות שנבחרה אינה זמינה כרגע.', 'error');
    } else if (!state.busy) {
      setStatus('', '');
    }
    return variant;
  }

  function verifyProduct(product) {
    if (!product || Number(product.id) !== Number(config.productId) ||
        product.handle !== config.handle || !Array.isArray(product.variants)) {
      throw new Error('product-mismatch');
    }
    var expectedVariants = config.allowedVariantIds || [];
    if (product.variants.length !== expectedVariants.length) {
      throw new Error('variant-mismatch');
    }
    for (var i = 0; i < expectedVariants.length; i += 1) {
      var found = false;
      for (var j = 0; j < product.variants.length; j += 1) {
        if (Number(product.variants[j].id) === Number(expectedVariants[i])) found = true;
      }
      if (!found) throw new Error('variant-mismatch');
    }
    if (config.fixedVariantId && Number(product.variants[0].id) !== Number(config.fixedVariantId)) {
      throw new Error('variant-mismatch');
    }
    return product;
  }

  function loadProduct() {
    if (state.request) return state.request;
    var url = '/products/' + encodeURIComponent(config.handle) + '.js';
    state.request = fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('product-load-failed');
      return response.json();
    }).then(verifyProduct);
    return state.request;
  }

  function bind(parts) {
    if (!parts || !parts.root || !parts.form) return;
    if (state.form === parts.form) {
      state.root = parts.root;
      if (state.ready) refreshSelection();
      return;
    }

    state.root = parts.root;
    state.form = parts.form;
    state.status = ensureStatus(parts.root);
    state.ready = false;
    state.busy = false;
    if (config.pendingDisplay) parts.root.classList.add('bs-targeted-product-pending');
    setButtonsDisabled(true);
    setStatus('בודקים את פרטי המוצר…', '');

    loadProduct().then(function (product) {
      if (!state.form || state.form !== parts.form || !state.root) return;
      state.product = product;
      state.ready = true;
      if (config.pendingDisplay) state.root.classList.remove('bs-targeted-product-pending');
      refreshSelection();
    }).catch(function () {
      if (state.form !== parts.form) return;
      state.ready = false;
      setButtonsDisabled(true);
      setStatus('לא הצלחנו לאמת את פרטי המוצר. רעננו את הדף ונסו שוב.', 'error');
    });
  }

  function scan() {
    var parts = findHero();
    if (parts) bind(parts);
  }

  function heroForm(form) {
    if (!form) return false;
    var parts = findHero();
    return !!(parts && parts.form === form);
  }

  function messageForAddError(response) {
    return response && response.description
      ? 'לא הצלחנו להוסיף לעגלה: ' + response.description
      : 'לא הצלחנו להוסיף לעגלה. בדקו זמינות ונסו שוב.';
  }

  function addSelected() {
    if (state.busy) return;
    if (!state.ready) {
      setStatus('בודקים את פרטי המוצר. נסו שוב בעוד רגע.', 'error');
      return;
    }
    var variant = refreshSelection();
    if (!variant || variant.available !== true) return;

    var quantityInput = state.form.querySelector('input[name="quantity"], input.gf_pq_qty, select[name="quantity"]');
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
    if (!isFinite(quantity) || quantity < 1) quantity = 1;

    state.busy = true;
    var controls = state.form.querySelectorAll('.gf_add-to-cart, .gf_variants input, .gf_variants select');
    var previous = [];
    for (var i = 0; i < controls.length; i += 1) {
      previous.push({ element: controls[i], disabled: !!controls[i].disabled });
      controls[i].disabled = true;
    }
    setStatus('מוסיפים לעגלה…', '');

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: Number(variant.id), quantity: quantity }]
      })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw data || new Error('cart-add-failed');
        return data;
      });
    }).then(function () {
      setStatus('המוצר נוסף לעגלה.', 'success');
      window.location.assign('/cart');
    }).catch(function (error) {
      state.busy = false;
      for (var j = 0; j < previous.length; j += 1) {
        previous[j].element.disabled = previous[j].disabled;
      }
      refreshSelection();
      setStatus(messageForAddError(error), 'error');
    });
  }

  function intercept(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var button = target.closest('.gf_add-to-cart');
    var form = button ? button.closest('form') : null;
    if (!form || !heroForm(form)) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    addSelected();
  }

  function handleVariantChange(event) {
    if (!state.form || !state.form.contains(event.target)) return;
    if (state.ready && !state.busy) refreshSelection();
  }

  addStyle();
  window.addEventListener('click', intercept, true);
  window.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM' || !heroForm(form)) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    addSelected();
  }, true);
  document.addEventListener('change', handleVariantChange);
  document.addEventListener('input', handleVariantChange);
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    state.busy = false;
    scan();
    refreshSelection();
  });

  var pendingScan = false;
  function scheduleScan() {
    if (pendingScan) return;
    pendingScan = true;
    window.requestAnimationFrame(function () {
      pendingScan = false;
      scan();
    });
  }

  var observer = new MutationObserver(scheduleScan);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'hidden']
  });
  window.addEventListener('resize', scheduleScan, { passive: true });
  scan();
})();